export default "{\n    \"emptyText\": \"Haga clic para seleccionar una instalación\",\n    \"searchPlaceholderText\": \"Buscar por nombre o dirección\"\n}\n"